import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppService } from '../shared/service/AppService.class';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LeadService extends AppService<any>{

  constructor(protected http: HttpClient) {
    super(http);
    this.appmod = "lead";
  }

  getHeaders(data?:any){
    let tmp=this.appmod
    this.appmod='custom/getHeaders'
    let result = super.getService(data);
    this.appmod=tmp
    return result;
  }
  getLeadgroups(data?:any){
    let tmp=this.appmod
    this.appmod='custom/getLeadgroups'
    let result = super.getService(data);
    this.appmod=tmp
    return result;
  }


  public getassignleads(id): Observable<any> {
    let tmp=this.appmod
    this.appmod = "getassignleadsdata";
    let result = super.getService(id);
    this.appmod=tmp
    return result;
  }

  public checkvalidlist(id,type): Observable<any> {
    let tmp=this.appmod
    this.appmod = "checkallliststatus";
    let result = super.getService(id,type);
    this.appmod=tmp
    return result;
  }


  public headerData(groupID): Observable<any> {
    let tmp=this.appmod
    this.appmod = "custom/Leadheaderdata";
    let result = super.getService(groupID);
    this.appmod=tmp
    return result;
  }
  public saveHeaderMapping(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/saveheadermapping";
    let result = super.saveService(data);
    this.appmod = tmp;
    return result;
  }

  public getAgainCallLeads(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/getAgainCallLeads";
    let result = super.getService(data);
    this.appmod = tmp;
    return result;
  }

  
  public update_Lead(data: any,id:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/lead_update";
    let result = super.updateService(data,id);
    this.appmod = tmp;
    return result;
  }

  public deleteFile(data: any,type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/delete_file";
    let result = super.deleteService(data,type);
    this.appmod = tmp;
    return result;
  }

  public deleteUploadFile(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/deleteleadFile";
    let result = super.deleteService(data);
    this.appmod = tmp;
    return result;
  }

  public deleteGroup(data: any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/deleteGroup";
    let result = super.deleteService(data);
    this.appmod = tmp;
    return result;
  }
  
  public getleadReports(id:any): Observable<any> {
    let tmp=this.appmod
    this.appmod = "custom/getleadReports";
    let result = super.getService(id);
    this.appmod=tmp
    return result;
  }

  public getTopbox(id:any): Observable<any> {
    let tmp=this.appmod
    this.appmod = "custom/getleadTopbox";
    let result = super.getService(id);
    this.appmod=tmp
    return result;
  }
  public resetallleads(data: any,type:any): Observable<any> {
    let tmp = this.appmod;
    this.appmod = "custom/resetallleads";
    let result = super.getService(data,type);
    this.appmod = tmp;
    return result;
  }
}
